import { calculatorAppreciationToEquity } from '@arrived/common';
import {
  getLeaseStatusMessageDisplayText,
  MarketROI,
  Offering,
  OfferingDividend,
  OfferingTransaction
} from '@arrived/models';

import { DocumentSignedEventProperties } from '../EventProperties';

import { getHistoricalReturnRange } from './getHistoricalReturnRange';

export const getDocumentsSignedProperties = (
  offering: Offering,
  offeringTransaction: OfferingTransaction,
  offeringDividends?: OfferingDividend[],
  marketROI?: MarketROI,
  extraFields?: Partial<DocumentSignedEventProperties>
): Partial<DocumentSignedEventProperties> => {
  const property = offering.properties[0];

  return {
    ...extraFields,
    asset_type: offering?.assetType,
    total_transaction_amount: offeringTransaction.totalAmount,
    revenue: offeringTransaction.totalAmount,
    currency: 'USD', // Need to change to not be hardcoded later
    num_shares_purchased: offeringTransaction.sharesCount,
    beds: property?.bedrooms,
    baths: (property?.fullBathrooms ?? 0) + (property?.halfBathrooms ?? 0),
    sq_ft: property?.squareFootage,
    year_built: property?.yearBuilt,
    number_of_investors: offering?.investorsCount,
    property_purchase_price: offering?.totalPurchasePrice,
    monthly_rent: property?.rent,
    offering_id: offering?.id,
    property_name: offering?.name.toLowerCase(),
    perc_purchased_status: offering?.fundedPercent,
    property_rental_status: getLeaseStatusMessageDisplayText(property?.leaseStatus),
    first_dividend_date: offering?.projectedFirstDividendDate ?? undefined,
    first_dividend_yield: offering?.projectedAnnualDividendYield ?? undefined,
    ...getHistoricalReturnRange(
      offering,
      {
        lower: calculatorAppreciationToEquity(offering.projectedAppreciationLower ?? 0, offering),
        upper: calculatorAppreciationToEquity(offering.projectedAppreciationUpper ?? 0, offering),
      },
      offeringDividends
    ),
    historical_rental_dividends: marketROI?.averageDividend,
    property_value_growth: offering?.projectedAppreciationLower ?? undefined,
  };
};
